import { onBeforeUnmount, onMounted } from 'vue'

export interface DocumentReviewShortcutOptions {
  /** `false` com modal aberto, carregando, salvando ou sem documento ativo. */
  isEnabled: () => boolean
  onNext: () => void
  onPrevious: () => void
  onApprove: () => void
  onReject: () => void
}

/** `<input>` que não recebe texto: com foco neles (ex.: checkbox do lote) os atalhos seguem valendo. */
const NON_TEXT_INPUT_TYPES = ['checkbox', 'radio', 'button', 'submit', 'reset', 'range', 'color']

const isEditableTarget = (target: EventTarget | null): boolean => {
  if (!(target instanceof HTMLElement)) return false
  if (target instanceof HTMLInputElement) return !NON_TEXT_INPUT_TYPES.includes(target.type)
  if (target instanceof HTMLTextAreaElement || target instanceof HTMLSelectElement) return true
  return (
    target.isContentEditable ||
    target.closest('[contenteditable]:not([contenteditable="false"])') !== null
  )
}

/**
 * Atalhos da revisão em sequência (G1 · Tela 2 · B): A aprovar, R reprovar, J/K próximo/anterior.
 * Nunca disparam digitando num campo nem com Ctrl/Meta/Alt (Ctrl+R continua recarregando a página).
 */
export function useDocumentReviewShortcuts(options: DocumentReviewShortcutOptions): void {
  const actions: Record<string, () => void> = {
    j: options.onNext,
    k: options.onPrevious,
    a: options.onApprove,
    r: options.onReject
  }

  const handler = (event: KeyboardEvent) => {
    if (event.ctrlKey || event.metaKey || event.altKey) return
    if (isEditableTarget(event.target) || !options.isEnabled()) return
    // `String()`: o autopreenchimento do Chrome dispara keydown sem `key`.
    const action = actions[String(event.key).toLowerCase()]
    if (!action) return
    event.preventDefault()
    action()
  }

  onMounted(() => window.addEventListener('keydown', handler))
  onBeforeUnmount(() => window.removeEventListener('keydown', handler))
}
